import { token } from '@atlaskit/tokens';
import { SelectOptionColor } from '@databases/model/field';
import { mapColorToNewPalette } from '@databases/utils/database/field-types/select';

import { ColorPalette } from './types';

export const newBackgroundColors: Record<string, string> = {
  grey: '#DDDEE1',
  blue: '#8FB8F6',
  teal: '#9DD9EE',
  red: '#FD9891',
  green: '#7EE2B8',
  purple: '#D8A0F7',
  lime: '#B3DF72',
  magenta: '#F797D2',
  orange: '#FBC828',
  yellow: '#EED12B',

  blueLight: token('color.background.accent.blue.subtlest'),
  redLight: token('color.background.accent.red.subtlest'),
  yellowLight: token('color.background.accent.yellow.subtlest'),
  greenLight: token('color.background.accent.green.subtlest'),
  tealLight: token('color.background.accent.teal.subtlest'),
  purpleLight: token('color.background.accent.purple.subtlest'),
  limeLight: token('color.background.accent.lime.subtlest'),
  magentaLight: token('color.background.accent.magenta.subtlest'),
  orangeLight: token('color.background.accent.orange.subtlest'),
  greyLight: token('color.background.accent.gray.subtlest'),
};

export const newBorderColors: Record<string, string> = {
  grey: '#DDDEE1',
  blue: '#8FB8F6',
  teal: '#9DD9EE',
  red: '#FD9891',
  green: '#7EE2B8',
  purple: '#D8A0F7',
  lime: '#B3DF72',
  magenta: '#F797D2',
  orange: '#FBC828',
  yellow: '#EED12B',

  blueLight: '#669DF1',
  redLight: '#F87168',
  yellowLight: '#DDB30E',
  greenLight: '#4BCE97',
  tealLight: '#6CC3E0',
  purpleLight: '#C97CF4',
  limeLight: '#94C748',
  magentaLight: '#E774BB',
  orangeLight: '#FCA700',
  greyLight: '#B7B9BE',
};

export const newTextColors: Record<string, string> = {
  blue: '#292A2E',
  red: '#292A2E',
  yellow: '#292A2E',
  green: '#292A2E',
  teal: '#292A2E',
  purple: '#292A2E',
  lime: '#292A2E',
  magenta: '#292A2E',
  orange: '#292A2E',
  grey: '#292A2E',
  blueLight: token('color.text'),
  redLight: token('color.text'),
  yellowLight: token('color.text'),
  greenLight: token('color.text'),
  tealLight: token('color.text'),
  purpleLight: token('color.text'),
  limeLight: token('color.text'),
  magentaLight: token('color.text'),
  orangeLight: token('color.text'),
  greyLight: token('color.text'),
};

export const TagColorPaletteADSRefresh: ColorPalette<SelectOptionColor> = {
  borderColor: (color) => newBorderColors[mapColorToNewPalette(color)],
  backgroundColor: (color) => newBackgroundColors[mapColorToNewPalette(color)],
  textColor: (color) => newTextColors[mapColorToNewPalette(color)],
  swatch: [
    'greyLight',
    'blueLight',
    'tealLight',
    'greenLight',
    'limeLight',
    'purpleLight',
    'magentaLight',
    'redLight',
    'orangeLight',
    'yellowLight',

    'greyDark',
    'blueDark',
    'tealDark',
    'greenDark',
    'limeDark',
    'purpleDark',
    'magentaDark',
    'redDark',
    'orangeDark',
    'yellowDark',
  ],
};
